export const projects = [
  {
    title: "Merlin Solutions ",
    subtitle: "Full Stack Developer",
    description:
      "I have been working here for more than 6 months. I have been working with different programming languages named Vue.js, Flutter, JavaScript etc. I have a strong collabration with my team. Most of the time we are using Slack, Confluence, Teams and Bitbucket to evaluate our work and communication. If you click on this block you will be redirected to our most amazing website that we built. Currently we are working on the financial app called Merlinc which we mostly used Flutter and the project is live through AWS.",
      image: "./computer.jpeg",
    link: "https://apps.apple.com/ca/app/merlinc/id6443903541",
  },
  {
    title: "DigiKala",
    subtitle: "Front End Developer",
    description:
      "Wen I was in my home country I workked in this company as an internship. The main programming language we wrote were JavaScript and React. Me and my team did some projects which was related to the ATM machines. I collabrated in sharing ideas and suggestions in team meetings and delivered updates on deadlines, designs and enhancements.",
    image: "./laptop.jpeg",
    link: "",
  },
];

export const educations = [
  {
    quote:
    "College Diploma",
     image: "https://randomuser.me/api/portraits/men/1.jpg",
     name: "Computer Programming",
    company: "Seneca College",
    
  },
  {
    quote:
      "BS in Computer Software Engineering",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Computer Software Engineering",
    company: "Tehran University",
  },
];

export const skills = [
  "JavaScript",
  "React",
  "Next.js",
  "Node",
  "SQL Server",
  "Vue.js",
  "Dart",
  "MongoDB",
  "Python",
  "Express.js",
];



// WEBPACK FOOTER //
// ./src/data.js